import { render, staticRenderFns } from "./SheetEquipmentControls.vue?vue&type=template&id=56c6165f&scoped=true&"
import script from "./SheetEquipmentControls.vue?vue&type=script&lang=js&"
export * from "./SheetEquipmentControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6165f",
  null
  
)

export default component.exports